import React from 'react';
import './FallingFlakes.css';

/**
 * FallingFlakes - A reusable component for animated falling snowflakes
 * @param {Object} props
 * @param {number} props.height - Height of the container (default: 64)
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.style - Additional inline styles
 */
const FallingFlakes = ({ height = 64, className = '', style = {} }) => {
  // Check if current month is December (0-indexed, so 11 = December)
  // Use a ref to get the actual width for dynamic calculations
  const wrapperRef = React.useRef(null);
  const [containerWidth, setContainerWidth] = React.useState(0);

  const currentMonth = new Date().getMonth();
  const isDecember = currentMonth === 11;
  
  React.useEffect(() => {
    if (wrapperRef.current) {
      setContainerWidth(wrapperRef.current.offsetWidth);
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          setContainerWidth(entry.contentRect.width);
        }
      });
      resizeObserver.observe(wrapperRef.current);
      return () => resizeObserver.disconnect();
    }
  }, []);
  // Don't render if not December
  if (!isDecember) {
    return null;
  }



  return (
    <div 
      ref={wrapperRef}
      className={`falling-flakes-wrap ${className}`}
      style={{ 
        height: `${height}px`, 
        width: '100%',
        '--container-height': `${height}px`,
        '--container-width': `${containerWidth}px`,
        overflow: 'hidden', // Ensure clipping to header height
        ...style 
      }}
    >
      <div className="falling-flakes">
        <div className="flakes flakes1" style={{ width: containerWidth || '100%' }}>❄</div>
        <div className="flakes flakes2" style={{ width: containerWidth || '100%' }}>❄</div>
        <div className="flakes flakes3" style={{ width: containerWidth || '100%' }}>❄</div>
        <div className="flakes flakes4" style={{ width: containerWidth || '100%' }}>❄</div>
      </div>
    </div>
  );
};

export default FallingFlakes;

